import { render, staticRenderFns } from "./ProspectContactUpdate.vue?vue&type=template&id=19f0e91e"
import script from "./ProspectContactUpdate.vue?vue&type=script&lang=ts"
export * from "./ProspectContactUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports